module.exports = __webpack_public_path__ + "img/all-secure-3ds.ce52d1a7.svg";